import { h } from '@stencil/core';
export const OfflineStoresUI = (props) => {
  const { timeLabel, time, legalText } = props || null;
  return (h("div", { class: "offline-stores" }, timeLabel && (h("div", { class: "offline-stores--delivery" }, h("span", null, `${timeLabel} `), h("p", { class: "offline-stores--delivery-time", innerHTML: time }), legalText && (h("pdp-icon-tooltip", { iconColor: "grey", iconSize: "micro", icon: "information_stroke", innerHTML: legalText, class: "offline-stores--tooltip" }))))));
};
